import { userTypes } from "./user.types";

const INITIAL_STATE = {
  userChannels: {
    loading: true,
    data: [],
  },
  agent: {
    loading: true,
    data: {},
  },
  agents: {
    loading: false,
    data: null,
  },
  container: {
    loading: false,
    data: {},
  },
  profile: {
    isFetching: false,
    data: null,
    error: null,
  },
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //
    case userTypes.SET_CONTAINER_INFO:
      return {
        ...state,
        container: {
          loading: false,
          data: action.payload,
        },
      };

    case userTypes.SET_CONVERSATIONS_CHARGE: {
      return {
        ...state,
        container: {
          ...state.container,
          data: {
            ...state.container.data,
            account: {
              ...state.container.data.account,
              conversationCharge: action.payload,
            },
          },
        },
      };
    }

    case userTypes.SET_USER_CHANNELS:
      return {
        ...state,
        userChannels: {
          data: action.payload,
          loading: false,
        },
      };

    case userTypes.LOAD_AGENT:
      return {
        ...state,
        agent: {
          ...state.agent,
          loading: action.payload,
        },
      };

    case userTypes.SET_AGENT_INFO:
      return {
        ...state,
        agent: {
          loading: false,
          data: {
            ...state.agent.data,
            ...action.payload,
          },
        },
      };

    case userTypes.SET_AGENTS:
      return {
        ...state,
        agents: {
          ...state.agents,
          data: action.payload,
        },
      };

    case userTypes.POST_USER_DATA_OF_OTP_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          isFetching: true,
          data: action.payload,
        },
      };
    case userTypes.POST_USER_DATA_OF_OTP_FAILURE:
      return {
        ...state,
        profile: {
          ...state.profile,
          isFetching: false,
          data: action.payload,
        },
      };

    default:
      return state;
  }
};

export default userReducer;
